import React, {useState} from "react";
import {useDispatch} from "react-redux";
import {format} from "date-fns";
import koLocale from "date-fns/locale/ko";
import {changeStatus} from "../../redux/slice/inputSlice";
import {handleActiveError, handleActiveToast} from "../sonner/ToastBasic";
import {userAuth} from "../../constant/CodeSpecNum";
import {setIndividualSetting} from "../../api/user/UserAccountService";

let flat_code = [];
const currentCode = new Array(); // 들어온 코드값
let path_label = []; // 코드명 텍스트 경로
export const VH = window.innerHeight * 0.01;


export const getDateTwoByDot =(date)=>{
    if(date) {
        const newDate = new Date(date);
        const result = `${(newDate.getFullYear()).toString().substring(2, 4)}-${(newDate.getMonth() + 1).toString().padStart(2, '0')}-${newDate.getDate().toString().padStart(2, '0')}`;

        return result;
    }else {
        return "-";
    }
}

const SIMMS_DISPLAY_DATE_FORMAT = "yy-MM-dd";

/** 목록·상세 공통 — 날짜만 yy-MM-dd (시간 제외) */
export function formatSimmsDateTime(value) {
    if (value == null || value === "") return "";
    if (value instanceof Date) {
        if (Number.isNaN(value.getTime())) return "";
        return format(value, SIMMS_DISPLAY_DATE_FORMAT, {locale: koLocale});
    }
    if (typeof value !== "string") return String(value);

    const text = value.trim();
    if (!text) return "";

    if (/^\d{4}-\d{2}-\d{2}/.test(text)) {
        try {
            const normalized = text.length <= 10 ? text : text.replace(" ", "T");
            const d = new Date(normalized);
            if (!Number.isNaN(d.getTime())) {
                return format(d, SIMMS_DISPLAY_DATE_FORMAT, {locale: koLocale});
            }
        } catch {
            /* fall through */
        }
    }

    return text;
}

/** 상세 KV·읽기 전용 — yy-MM-dd (시간 제외) */
export function formatSimmsDateTimeKorean(value) {
    return formatSimmsDateTime(value);
}

function isSimmsDateLikeField(field) {
    if (typeof field !== "string" || !field) return false;
    const leaf = field.split(".").pop() ?? field;
    return /(?:At|Time|DateTime|Datetime|Date|date)$/i.test(leaf);
}

function shouldAutoFormatDateCell(field, raw) {
    if (raw == null || raw === "") return false;
    if (typeof raw !== "string") return false;
    const text = raw.trim();
    if (!/^\d{4}-\d{2}-\d{2}/.test(text)) return false;
    if (isSimmsDateLikeField(field)) return true;
    return text.length > 10;
}

function simmsDateTimeToJsGridRender(col) {
    const field = col.field;
    return ({row, value, columnKey}) => {
        const raw = value ?? getNestedValueForSimmsGrid(row, columnKey ?? field, col.short);
        const text = formatSimmsGridCell(field, raw);
        return text !== "" && text != null ? String(text) : "\u00A0";
    };
}

/** SimmsTable·JsGrid 공통 셀 표시 */
export function formatSimmsGridCell(field, raw) {
    if (shouldAutoFormatDateCell(field, raw)) {
        return formatSimmsDateTime(raw);
    }
    return raw ?? "";
}

export const korTime = (date) => {
    const newDate = new Date(date);
    // newDate.setHours(0, 0, 0, 0); // 00:00:00으로 시간 설정
    newDate.setHours(newDate.getHours() + 9); // UTC+9로 조정
    return newDate.toISOString().substring(0, 19);
};

const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
const toKSTISOString = (date) => {
    const newDate = new Date(date);
    newDate.setHours(0, 0, 0, 0); // 00:00:00으로 시간 설정
    newDate.setHours(newDate.getHours() + 9); // UTC+9로 조정
    return newDate.toISOString().substring(0, 19);
};

// KST (한국 표준시)로 변환된, 해당 날짜의 마지막 시간 (23:59:59) ISO 문자열 반환
const toKSTISOStringEnd = (date) => {
    const newDate = new Date(date);
    newDate.setHours(23, 59, 59, 999); // 23:59:59으로 시간 설정
    newDate.setHours(newDate.getHours() + 9); // UTC+9로 조정
    return newDate.toISOString().substring(0, 19);
};

//섹션 요소 접기 / 펼치기
function toggleSection(sectionId) {
    const section = document.getElementById(sectionId);
    if (section) {
        const table = section.querySelector('table');
        const article = section.querySelector('article');
        if (table) {
            table.style.display = (table.style.display === 'none') ? 'block' : 'none';
        }
        if (article) {
            article.style.display = (article.style.display === 'none') ? 'block' : 'none';
        }
        section.classList.toggle('section-with-border');
    }
}


/**
 * code 의 부모-자식 간 중첩상태를 풀어서 1차원 배열로 flat
 * */
const getFlatCode = (code) => {
    flat_code = [];
    if(code) {
        code.forEach(root_node => {
            flattenTree(root_node);
        });
    }
    return flat_code;
};
const flattenTree=(node)=> {
    // 현재 노드의 id를 결과 배열에 추가
    flat_code.push(node);
    // 현재 노드의 children 배열을 순회하면서 재귀적으로 호출
    node.children?.forEach(child => {
        flattenTree(child);
    });
}

//본인의 이름을 추가하고 id 값이 셋 된 경우(부모가 null  이 아닌)에만 부모 찾기
function getRecursive(id,name) {
    path_label.push(name)           // 본인의 이름을 담음
    const temp = flat_code.find(    // 부모객체를 찾음
        each => each.id ===id
    )
    if (temp) {
        getAllFieldOfParent(temp);  // 부모객체로 재귀호출
    }

}
function getAllFieldOfParent(matchedCode){
    if(matchedCode) {
        currentCode.push(matchedCode.id)
        let id =null;       // 부모 키
        let name= matchedCode.name;
        if (matchedCode.parentId !== (undefined && null)) {     //code 는 부모 키가 parentId 에 있음
            id =matchedCode.parentId;
        }else if(matchedCode.parent && matchedCode.parent.id !== (undefined && null)){  //customCode 는 parent에 부모 객체가 있어서 parent.id 로 찾아야함
            id =matchedCode.parent.id;
        }
        if(id!=null) getRecursive(id, name);
    }
};


// 코드객체, 자식객체를 받아서 역순으로 최상위 부모를 찾아가는 함수
export function getVeryParentId(array, child){
    const flatArray = getFlatCode(array);
    return reversedFlatCode(child, flatArray)[0];
}

function reversedFlatCode(code, array){
    if(array) flat_code = array
    if(code && flat_code.length > 0){
        currentCode.splice(0);
        getAllFieldOfParent(code)
        return currentCode.reverse();;
    }
}


function descToAsc(code, array){
    path_label = [];
    if(array) flat_code = array

    if(code && flat_code.length > 0){
        currentCode.splice(0);
        getAllFieldOfParent(code)
        currentCode.reverse();
        path_label.reverse();
        return path_label.join(" > ");
    }
}

async function callAsyncHandler(asyncFunction ) {
    try {
        const response = await asyncFunction();
        if(response.status === 200) {
            return response.data;
        }
        return null;
    } catch (error) {
        return null;
    } finally {
    }
}

export function requiredChecker(f, target, valid) {
    f(prev => ({
    ...prev,
    required_validate: { ...prev?.required_validate, [target]: valid }
}));

}


export function isUpdate(a, b) {
    return a && b;
}

function validationChecker(obj) {
    // 필수값 검증 결과를 참/거짓으로 반환
    if(!obj.required_validate){
        alert("필수값이 누락되었습니다.")
        return false;
    }
    for (let key in obj.required_validate) {
        if (Array.isArray(obj.required_validate[key])) {
            for (let i = 0; i < obj.required_validate[key].length; i++) {
                if (obj.required_validate[key][i] === false) {
                    console.log(obj.required_validate[key][i])
                    alert("필수값이 누락되었습니다.")
                    return false;
                }
            }
        } else {
            if (obj.required_validate[key] !== true) {

                alert("필수값이 누락되었습니다.")
                return false;
            }
        }
    }
    return true;
}

function getInvalidatedTarget(obj) {
    //필수값중 입력되지 않은 요소들 target명 반환
    const falseElements = [];
    for (let key in obj.required_validate) {
        if (Array.isArray(obj.required_validate[key])) {
            for (let i = 0; i < obj.required_validate[key].length; i++) {
                if (obj.required_validate[key][i] !== true) {
                    falseElements.push(key+"_"+i);
                }
            }
        } else {
            if (obj.required_validate[key] !== true) {
                falseElements.push(key);
            }
        }
    }
    console.log(falseElements);

    return falseElements;
}

export function getUrl(target, search,pageable){
    const page = getPages(pageable)
    return '/' + target+'?'+getPages(pageable)+'&'+encodeQueryData(search);
}
export function getPages(pageable) {
        let sort = "sort=";
        let size = '&size=';
        let page = '&page=';
        const desc = ',desc';
        if (pageable?.sort) {
            sort += pageable.sort
            if (pageable.desc) {
                sort += desc;
            }
        }

        if (pageable?.size) {
            size += pageable.size;
        }
        page += pageable?.page;
        return sort + size + page;
}
export function encodeQueryData(search) {
    const searchDto = {};
    for (const key in search) {
        if (search.hasOwnProperty(key)) {
            if (typeof search[key] === 'object' && search[key] !== null) {
                searchDto[key] = search[key].id;
            } else {
                searchDto[key] = search[key];
            }
        }
    }
    const ret = [];
    for (const key in searchDto) {
        ret.push(encodeURIComponent(key) + '=' + encodeURIComponent(searchDto[key]));
    }
    return ret.join('&');
}

export function objectTypeChecker(val) {
    // 기존에 객체만 체크하던 부분을 []검색어로 변경되면서 확장추가
    return Object.prototype.toString.call(val) === '[object Object]' || Object.prototype.toString.call(val) === '[object Array]';
}

export function extractObject(obj){
    const result = {};
    Object.entries(obj).forEach(([key, value]) => {
        if(objectTypeChecker(value)) result[key] = value
    });
    
    return obj
}

export function extractNonObject(obj){
    const result = {};
    Object.entries(obj).forEach(([key, value]) => {
        if(!objectTypeChecker(value)) result[key] = value
    });
    return result
}

function getTextLimitBy(text, limit){
    if(text !=undefined && text.trim() !=''){
        if (text.length <= limit) {
            return text;
        }else{
            return text.substring(0,limit)+'...';
        }
    }
}


function getBackwardTextLimitBy(text, limit){
    if(text !=undefined && text.trim() !=''){
        if (text.length <= limit) {
            return text;
        }else{
            return '...' + text.substring(text.length-limit,text.length);
        }
    }
}

function useFocusOutHandler(value) {
    const [clicked, setClicked] = useState(false);
    const [changedValue, setChangedValue] = useState(value);

    const dispatch = useDispatch();

    function onFocusOut() {
        setClicked(false);
        setChangedValue(value);
    }

    function clickFunction() {
        dispatch(changeStatus(false))
        setClicked(true);
    }

    return {
        clicked,
        setClicked,
        changedValue,
        onFocusOut,
        clickFunction,
        setChangedValue
    };
}

function getIdsFromMulipleMeToParent(idList, targetCodes) {
    const result = [];
    const flatCode = getFlatCode(targetCodes);
    idList.forEach(each=> findParent(each, flatCode, result))
    return result;
}

function getToken() {
    return localStorage.getItem("accessToken");
}


function getIdsFromMeToParent(me, targetCodes) {
    const result = [];
    const flatCode = getFlatCode(targetCodes);
    findParent(me, flatCode, result);
    return result;
}

function findParent(me, flatCode, result) {
    if(me) {
        result.push(me.id);
        if(me.parent && me.parent.id){
            findParent(me.parent, flatCode, result);
        }
        else if(me.parentId){
            findParent(getCodeFromFlatCode(me.parentId, flatCode), flatCode, result);
        }
    }
}

function getCodeFromFlatCode(id, array) {
    return array.find(each=>each.id === id);
}


async function generateSequentialNumber(guery,sequentialPartLength) {
    const lastNumber = await guery();

}

function formatNumber(num){
    return num && num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

function commonResponseMessage(response, add, content){
    const message = add ? "추가" : "삭제";
    if (response.status === 200) {
        handleActiveToast({message: content+"이(가) "+message+"되었습니다"});
    }
    return response;
}

function commonChangeResponseMessage(response, content){
    const message = "변경";
    if (response.status === 200) {
        handleActiveToast({message: content+"이(가) "+message+"되었습니다"});
    }
    return response;
}

export function doRest(rest, parameter) {
    if (rest) {
        Object.entries(rest).forEach(([key, value]) => {
            if (typeof value === 'function') {
                value(parameter); // 함수 호출
            }
        });
    }
}

// string, number타입만 검사
function isEmpty(value) {
    return (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) || (typeof value === 'number' && isNaN(value));
}

const parseBoolean = (value) => {
    if (value === "true") {
        return true;
    } else if (value === "false") {
        return false;
    }
    return value;
}

function isAdmin(user){
    const roles = getRoleArray(user);
    return (roles?.includes(userAuth.ADMIN.auth) || roles?.includes(userAuth.SYSTEM.auth))
}

function isSystem(user){
    const roles = getRoleArray(user);
    return (roles?.includes(userAuth.SYSTEM.auth))
}

// user가 useSelector의 user.auth(ROLE_ADMIN, ROLE_SYSTEM)
// 사용자 상세보기의 user는 user.roles([ADMIN, SYSTEM])
// 위의 결과로 admin, system체크 함수에 추가
function getRoleArray(user) {
    if (!user) return [];
    if (Array.isArray(user.roles)) {
        return user.roles.map(role => {
            if (role.startsWith("ROLE_")) return role;
            return "ROLE_" + role;
        });
    }

    if (typeof user.auth === "string") {
        return user.auth.split(",").map(role => role.trim());
    }
    return [];
}

export function maintenanceVaild(handler, data, requireds){
    if(handler.length == 0){
        alert("담당자를 선택해주세요")
        return false;
    }
    
    if(requireds.some(e=> isEmpty(data[e]))){
        alert("필수값이 누락되었습니다.")
        return false;
    }

    return true;
}

export const getFirstField = (field) => (Array.isArray(field) ? field[0] : field);
export function reArrange(a, b, headerOrder){
    const aField = getFirstField(a.field);
    const bField = getFirstField(b.field);

    const findIndexInHeaderOrder = (field) =>
        headerOrder.findIndex(orderField =>
            getFirstField(orderField) === field
        );

    const aIndex = findIndexInHeaderOrder(aField);
    const bIndex = findIndexInHeaderOrder(bField);
    // a 또는 b가 headerOrder에 없으면 맨 뒤로 가도록 처리
    if (aIndex === -1 && bIndex === -1) {
        return 0; // 둘 다 없는 경우 순서 변경 안 함
    }
    if (aIndex === -1) {
        return 1; // a만 없으면 b가 우선
    }
    if (bIndex === -1) {
        return
    }
        return aIndex - bIndex;
}

export function isExcluded(data, exclude) {
    const headerField = getFirstField(data); // header의 field 값 처리
    return exclude.some(ex => {
        const excludeField = getFirstField(ex); // exclude의 field 값 처리
        return headerField === excludeField; // 동일한 값 체크
    });
}


function getFristMenu(menus) {
    if (menus) {
        const zeroPage = menus[0]
        if (!zeroPage.url && zeroPage.children.length > 0) {
            return getFristMenu(zeroPage.children)
        } else {
            return zeroPage;
        }
    } else {
        return {url: ''}
    }
}

export function getFistPage() {
    const menu = localStorage.getItem('menus');
    const menus = JSON.parse(menu);
    return getFristMenu(menus);

}

export function excelFileCheck(file){
    const EXCEL_TYPE = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet','application/haansoftxlsx'];

    const ext = file.name.split('.').pop().toLowerCase();
    return EXCEL_TYPE.includes(file.type) || ["xlsx", "xls"].includes(ext)
}
export function getFilteredMenu() {
    const menu = getMenuJson();
    return localStorage.getItem("topMenuId") ? menu.filter(each => each.id == localStorage.getItem("topMenuId")) : [menu[0]];
}

export function getMenuJson() {
  const menus = localStorage.getItem('menus');
  return  JSON.parse(menus);
}

function normalizeMenuPath(path) {
    if (!path) return "/";
    let p = String(path).split("?")[0].split("#")[0];
    if (!p.startsWith("/")) p = `/${p}`;
    if (p.length > 1 && p.endsWith("/")) p = p.slice(0, -1);
    return p;
}

/**
 * 메뉴 url 과 현재 경로의 매칭 점수.
 * 정확히 일치 > 하위 경로(접두) 일치 > 첫 세그먼트만 일치 순으로 우선한다.
 * (서로 다른 탑메뉴가 같은 첫 세그먼트(`/settings` 등)를 공유할 때
 *  첫 세그먼트만 일치하는 다른 탑메뉴가 잘못 활성화되는 문제 방지)
 */
function menuUrlMatchScore(menuUrl, currentPath) {
    const menuPath = normalizeMenuPath(menuUrl);
    if (menuPath === currentPath) return 100000 + menuPath.length;
    if (menuPath !== "/" && currentPath.startsWith(`${menuPath}/`)) return 10000 + menuPath.length;
    const menuSeg = menuPath.split("/").filter(Boolean)[0];
    const currentSeg = currentPath.split("/").filter(Boolean)[0];
    if (menuSeg && currentSeg && menuSeg === currentSeg) return 1;
    return 0;
}

function menuTreeMatchScore(node, currentPath) {
    let best = node?.url ? menuUrlMatchScore(node.url, currentPath) : 0;
    if (node?.children) {
        for (const child of node.children) {
            const childScore = menuTreeMatchScore(child, currentPath);
            if (childScore > best) best = childScore;
        }
    }
    return best;
}

/** 현재 URL이 속한 1뎁스(TopMenu) id */
export function getTopMenuIdByPathname(pathname, menus = null) {
    const roots = menus ?? getMenuJson();
    if (!roots?.length || !pathname) return null;

    const currentPath = normalizeMenuPath(pathname);
    let matchedRoot = null;
    let bestScore = 0;
    for (const root of roots) {
        const score = menuTreeMatchScore(root, currentPath);
        if (score > bestScore) {
            bestScore = score;
            matchedRoot = root;
        }
    }
    return matchedRoot ? String(matchedRoot.id) : null;
}

export function initHeaderOrders(r, mergedHeaders, setHeader, exclude, setExclude, setPin, target) {
    let tf = true;
    setHeader({order: [...mergedHeaders], exclude: []});

    if (r.status === 200) {
        const savedHeader = JSON.parse(r.data.headers)?.[target];
        if (savedHeader) {
            const headerOrder = savedHeader?.orders;
            const savedExcluded = savedHeader?.excluded ?? [];
            const widths = savedHeader?.widths ?? {};

            const sortedHeaders = headerOrder
                ? [...mergedHeaders].slice().sort((a, b) => reArrange(a, b, headerOrder))
                : [...mergedHeaders];

            const appliedWidthHeaders = sortedHeaders.map((col) => {
                const field = getFirstField(col.field);
                const savedWidth = Number(widths?.[field]);

                if (Number.isFinite(savedWidth) && savedWidth > 0) {
                    return {...col, width: Math.round(savedWidth)};
                }

                return col;
            });

            setHeader({order: appliedWidthHeaders, exclude: savedExcluded});
            setExclude(savedExcluded);
        }
    }else if(r.status === 201){
        tf = false;
    }

    setPin({on: tf, onChange: (v) => setIndividualSetting(v)});
}

function groupByGroupName(flatList) {
    const grouped = {};

    flatList.forEach(item => {
        const group = item.groupName;
        if (!grouped[group]) {
            grouped[group] = [];
        }
        grouped[group].push(item);
    });

    return Object.entries(grouped).map(([groupName, child]) => ({
        groupName,
        child,
    }));
}

function groupByGroupNameWithValues(codeList, data) {
    const grouped = {};

    codeList.forEach(item => {
        const { groupName, id: codeId } = item;
        if (!grouped[groupName]) {
            grouped[groupName] = [];
        }

        const related = data.filter(v => v.codeId === codeId);

        grouped[groupName].push(...related.map(({ assetId, value }) => ({
            assetId,
            codeId,
            value
        })));
    });

    return Object.entries(grouped).map(([groupName, child]) => ({
        groupName,
        child
    }));
}

/** 점검별(reportView) — 코드 항목 전체 + 저장값 병합 */
function buildReportViewGroups(codeList, flatData = []) {
    if (!codeList?.length) return [];

    const flat = Array.isArray(flatData) ? flatData : [];

    return groupByGroupName(codeList).map((group) => ({
        groupName: group.groupName,
        child: group.child.map((item) => {
            const existing = flat.find((v) => v.codeId === item.id);
            if (existing) {
                return { codeId: item.id, value: existing.value };
            }
            if (parseInt(item.type, 10) === 1) {
                return { codeId: item.id, value: 0 };
            }
            return { codeId: item.id };
        }),
    }));
}

export function numberWithCommas(x) {
    if(isEmpty(x)) return x;

    return x
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

// 서비스는 ids도 개별적으로 관리해야한다.
export const allCheckHandlerAtServiceRequest = (bool, search, setState, api) => {
    if (bool) {
        api(search).then(r => {
            if (r.status === 200) {
                r.data.forEach(item => {
                    setState(prev => {
                        const updated = { ...prev };
                        if (!Array.isArray(updated.handlers)) {
                            updated.handlers = [];
                        }

                        if (!Array.isArray(updated.handlers)) {
                            updated.handlerIds = [];
                        }

                        if (!updated.handlers.some(each => each.id === item.id)) {
                            updated.handlers = [
                                ...updated.handlers,
                                {...item}
                            ];

                            updated.handlerIds = [
                                ...updated.handlerIds,
                                item.id
                            ];

                        }
                        return updated;
                    });
                });
            }
        });
    } else {
        // 전체 해제 시
        setState(prev => {
            return {
                ...prev,
                handlers: []
            };
        });
    }
};

export const thisPageCheckHandlerAtServiceRequest = (bool, handlers, setState) => {
    handlers.forEach(handler => {
        setState(prevState => {
            const updated = { ...prevState };
            if (!Array.isArray(updated.handlers)) {
                updated.handlers = [];
            }

            if (!Array.isArray(updated.handlerIds)) {
                updated.handlerIds = [];
            }

            if (!bool) {
                updated.handlers = updated.handlers.filter(
                    each => each.id !== handler.id
                );

                updated.handlerIds = updated.handlerIds.filter(
                    each => each !== handler.id
                );
            } else {
                // 체크
                if (!updated.handlers.some(each => each.id === handler.id)) {
                    updated.handlers = [
                        ...updated.handlers,
                        {...handler}
                    ];

                    updated.handlerIds = [
                        ...updated.handlerIds,
                        handler.id
                    ];
                }
            }

            return updated;
        });
    });
};

export const allCheckHandlerAtDrawerArray = (bool, search, fnc, api, target) => {
    // target이 있을 때는 객체안의 배열 없으면 단순 배열
    if (bool) {
        api(search).then(r => {
            if (r.status === 200) {
                if (target) {
                    fnc(prev => ({
                        ...prev,
                        [target]: r.data
                    }));
                } else {
                    fnc(r.data);
                }
            }
        });
    } else {
        if (target) {
            fnc(prev => ({
                ...prev,
                [target]: []
            }));
        } else {
            fnc([]);
        }
    }
};

export const thisPageCheckHandlerAtDrawerArray = (bool, obj, fnc, target) => {
    // target이 있을 때는 객체안의 배열 없으면 단순 배열
    if (target) {
        fnc(prev => {
            const prevArr = prev?.[target] || [];
            let newArr;
            if (bool) {
                // 체크: 기존에 없는 것만 추가
                newArr = [
                    ...prevArr,
                    ...obj.filter(each => !prevArr.some(p => p.id === each.id))
                ];
            } else {
                // 해제: obj에 포함된 id만 제거
                newArr = prevArr.filter(p => !obj.some(each => each.id === p.id));
            }
            return { ...prev, [target]: newArr };
        });
    } else {
        fnc(prev => {
            if (bool) {
                return [
                    ...prev,
                    ...obj.filter(each => !prev.some(p => p.id === each.id))
                ];
            } else {
                return prev.filter(p => !obj.some(each => each.id === p.id));
            }
        });
    }
};


export async function checkDuplicate(msg, v, fnc){
    const r = await fnc(v)
    if (r.status === 201 || (r.status === 202)) {
        handleActiveError({message: msg ?? r.data.title, description: r.data.reason});
        return r;
    }
}

export function isValidValue(value) {
    // 허용 문자: 영문, 숫자, 공백, 괄호류, 연산자, 따옴표, 밑줄
    const regex = /[^A-Za-z0-9\s\[\]\(\)\{\}\+\-\=\/\*'\"_]/;
    if (typeof value !== 'string') value = String(value);

    return !regex.test(value);
}

export function decodeToken(token){
    const [, payload] = token.split('.');
    if (!payload) throw new Error('Malformed JWT');

    let b64 = payload.replace(/-/g, '+').replace(/_/g, '/');

    const padLen = (4 - (b64.length % 4)) % 4;
    if (padLen) b64 += '='.repeat(padLen);

    const jsonStr = new TextDecoder().decode(
        Uint8Array.from(atob(b64), c => c.charCodeAt(0))
    );

    return jsonStr;
}

export function nonObject(condition, v, f, key) {
    const cur = condition || {};
    const next =
        cur[key] === v
            ? (({ [key]: _omit, ...rest }) => rest)(cur) // 같은 값 → 제거
            : { ...cur, [key]: v };                      // 다른 값 → 설정/변경

    f?.(next);
}

// 간단한 해시(데모용). 운영이면 crypto.subtle SHA-256로 바꾸는 걸 권장.
export const simpleHash = (str) => {
    let h = 2166136261;
    for (let i = 0; i < str.length; i++) {
        h ^= str.charCodeAt(i);
        h += (h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24);
    }
    return (h >>> 0).toString(16);
};

export const makeThreadKey = (keys) => {
    const normalized = Array.isArray(keys) ? [...keys].sort() : [];
    return simpleHash(JSON.stringify(normalized));
};

export const makeQueryKey = ({ threadKey, startDate, endDate }) => {
    return simpleHash(`${threadKey}|${startDate || ""}|${endDate || ""}`);
};


export const convertHeaders = (config) => {
    const excludeSet = new Set(config.exclude || []);

    return config.order
        .filter((col) => !excludeSet.has(col.field))
        .map((col) => ({
            key: col.field,
            label: col.name,
            type: "text", // 기본 타입
            width: col.width,
        }));
};

/** SimmsTable `renderer`가 React 컴포넌트(훅 사용)인지 인라인 렌더 함수인지 구분 */
function shouldMountSimmsRendererAsComponent(renderer) {
    if (typeof renderer !== "function") return false;
    if (renderer.prototype?.isReactComponent) return true;
    const name = renderer.displayName || renderer.name || "";
    return (
        name.length > 0
        && name[0] === name[0].toUpperCase()
        && name[0] !== name[0].toLowerCase()
    );
}

function simmsRendererArgs(args) {
    const { row, value, columnKey, rowIndex, stopRowClick } = args;
    return {
        keys: row?.id,
        data: value,
        item: row,
        row,
        value,
        columnKey,
        rowIndex,
        stopRowClick,
    };
}

/** SimmsTable `renderer` → JsGrid `render` (keys, data, item props 유지) */
function simmsRendererToJsGridRender(renderer) {
    if (renderer == null) return undefined;
    if (typeof renderer !== "function") return renderer;
    return (args) => {
        const simmsProps = simmsRendererArgs(args);
        // `(data) => <span onClick>` 같은 인라인 렌더는 직접 호출(반환 JSX의 onClick 감지 가능).
        // `ProgressStatusHandleBtn` 등 이름 있는 컴포넌트는 JSX로 마운트(훅 안전).
        if (shouldMountSimmsRendererAsComponent(renderer)) {
            const Renderer = renderer;
            return <Renderer {...simmsProps} />;
        }
        return renderer(simmsProps);
    };
}

/** Simms `editor` + `onSave` → JsGrid `editor` + `onChange` */
function simmsEditorToJsGridEditor(editor) {
    if (editor == null) return undefined;
    if (typeof editor !== "function") return editor;
    return (args) =>
        editor({
            ...args,
            onSave: async (_row, nextValue) => {
                args.onChange(nextValue, { close: true });
            },
        });
}

/** SimmsTable getNestedValue — objectArray 컬럼 표시용 */
function getNestedValueForSimmsGrid(obj, path, short) {
    if (path == null || path === "") return "";
    const pathStr = String(path);
    const value = pathStr.split(".").reduce((acc, part) => {
        if (Array.isArray(acc)) {
            if (short) {
                const [firstCount, unit] = short;
                const first = acc.slice(0, firstCount).map((item) => item[part]).join(", ");
                const count = acc.length - firstCount;
                return count > 0 ? `${first} 외 ${count}${unit}` : first;
            }
            return acc.map((item) => item[part]).join(", ");
        }
        return acc && acc[part];
    }, obj);
    return value ?? "";
}

function simmsColumnKey(col, index) {
    if (Array.isArray(col.field)) {
        return col.field.join("|");
    }
    if (col.field != null && col.field !== "") {
        return String(col.field);
    }
    return `col_${index}`;
}

function simmsDateArrayToJsGridRender(col) {
    const fields = col.field;
    const labels = col.label ?? [];
    return ({ row }) => (
        <>
            {fields.map((fieldName, index) => {
                const label = labels[index] ?? "";
                const raw = row?.[fieldName];
                const text =
                    raw == null || raw === ""
                        ? ""
                        : typeof raw === "string" && /At$/i.test(fieldName)
                          ? formatSimmsDateTime(raw)
                          : raw && typeof raw === "string"
                            ? formatSimmsDateTime(raw)
                            : raw != null
                              ? String(raw)
                              : "";
                return (
                    <p key={`${fieldName}_${index}`}>
                        {label + text}
                    </p>
                );
            })}
        </>
    );
}

function simmsObjectArrayToJsGridRender(col) {
    const fields = col.field;
    const labels = col.label ?? [];
    const short = col.short;
    return ({ row }) => (
        <>
            {fields.map((fieldPath, index) => {
                const label = labels[index] ?? "";
                const value = getNestedValueForSimmsGrid(row, fieldPath, short) ?? "";
                return (
                    <p key={`${fieldPath}_${index}`}>
                        {`${label} ${value}`}
                    </p>
                );
            })}
        </>
    );
}

/** 목록·엑셀 공통 — 컬럼 필터 플래그 (자산명 제외) */
export function applyColumnFilterFlags(col) {
    const key = typeof col?.field === "string"
        ? col.field
        : typeof col?.key === "string"
            ? col.key
            : null;

    if (key === "assetName") {
        return col;
    }

    const base = {...col, filterable: true};
    if (key === "operator" || key === "handler") {
        return {
            ...base,
            getFilterValue: (row) => {
                const users = row?.[key];
                if (!Array.isArray(users) || !users.length) return "";
                return users.map((u) => u?.name).filter(Boolean).join(", ");
            },
        };
    }
    return base;
}

/** Simms 컬럼({ field, name, render, renderer, editor }) → JsGrid header */
export function withListColumnFilters(columns = []) {
    const list = Array.isArray(columns)
        ? columns
        : Array.isArray(columns?.order)
            ? columns.order.filter((col) => !isExcluded(col.field, columns.exclude ?? []))
            : [];

    return list.map(applyColumnFilterFlags);
}

export function simmsColumnsToJsGridHeaders(columns = []) {
    const list = Array.isArray(columns)
        ? columns
        : Array.isArray(columns?.order)
            ? columns.order.filter((col) => !isExcluded(col.field, columns.exclude ?? []))
            : [];

    return list.map((col, index) => {
        let render =
            col.render != null
                ? col.render
                : col.renderer != null
                  ? simmsRendererToJsGridRender(col.renderer)
                  : undefined;

        if (render == null && col.type === "dateArray" && Array.isArray(col.field)) {
            render = simmsDateArrayToJsGridRender(col);
        } else if (render == null && col.type === "objectArray" && Array.isArray(col.field)) {
            render = simmsObjectArrayToJsGridRender(col);
        } else if (render == null && isSimmsDateLikeField(col.field)) {
            render = simmsDateTimeToJsGridRender(col);
        }

        const editor =
            col.editor != null ? simmsEditorToJsGridEditor(col.editor) : undefined;

        return {
            key: simmsColumnKey(col, index),
            label: col.name,
            type: col.type ?? "text",
            width: col.width,
            ...(col.short != null ? {short: col.short} : {}),
            ...(Array.isArray(col.label) ? {label: col.label} : {}),
            ...(render != null ? { render } : {}),
            ...(editor != null ? { editor } : {}),
            ...(col.filterable != null ? {filterable: col.filterable} : {}),
            ...(col.getFilterValue != null ? {getFilterValue: col.getFilterValue} : {}),
        };
    });
}

export const convertData = (rows) => {
    return {
        content: rows
    };
};

/** license 문자열에서 ASSET/USER 한도 초과 여부 파싱 */
export function parseLicenseExceed(license) {
    const parts = license?.split('_') ?? [];
    return {
        assetExceed: parts.some((part) => part.includes('ASSET')),
        userExceed: parts.some((part) => part.includes('USER')),
    };
}

/**
 * 등록(insert) 버튼 활성(Link) vs 비활성(license-out) 판별.
 * UtilsBox, MobileCreateButton 등에서 공통 사용.
 *
 * @param {{ license?: string, assetCheck?: boolean, userCheck?: boolean }} options
 */
export function canInsertByLicense({ license, assetCheck, userCheck }) {
    const { assetExceed, userExceed } = parseLicenseExceed(license);
    const hasAssetCheck = !!assetCheck;
    const hasUserCheck = !!userCheck;

    return (
        license === 'PASS' ||
        (license !== 'PASS' && !hasAssetCheck && !hasUserCheck) ||
        ((hasAssetCheck && !assetExceed) && (hasUserCheck && !userExceed))
    );
}

export {isMobile,getToken, toKSTISOString, toggleSection , getFlatCode, callAsyncHandler, descToAsc, validationChecker, getInvalidatedTarget, getTextLimitBy, getBackwardTextLimitBy, useFocusOutHandler, reversedFlatCode, toKSTISOStringEnd, getIdsFromMeToParent, getIdsFromMulipleMeToParent, formatNumber, commonResponseMessage,commonChangeResponseMessage, isEmpty,parseBoolean, isAdmin, isSystem, groupByGroupName, groupByGroupNameWithValues, buildReportViewGroups};